module.exports = __webpack_public_path__ + "static/media/uparrow.bd07dcd8.svg";